import { useQuery } from 'react-query';

import { DuplicateCheckResponse } from '../../../../backend/src/matter/procedural-timeline/dto/duplicate-check.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

/**
 * Checks a staged (not-yet-submitted) procedural upload against existing files
 * in the matter by content hash, so the upload dialog can warn before submit.
 * Advisory only: a duplicate is allowed, just flagged.
 */
export const useGetProceduralStagedDuplicate = (matterId: string, uploadId: string | null, filename: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<DuplicateCheckResponse, Error>(
    [QueryEntity.ProceduralTimelineStagedDuplicate, { matterId, uploadId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/staged-files/${uploadId}/duplicate-check?filename=${encodeURIComponent(
          filename ?? '',
        )}`,
        fetchConfigGET,
      );
      if (!res.ok) throw new Error('Failed to check for a duplicate file');
      return res.json();
    },
    { enabled: uploadId !== null && filename !== null, refetchOnWindowFocus: false, retry: false },
  );
};
